import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const organizationCustomerTypesAdapter = getAdapter({ idFieldName: 'value' });

const organizationCustomerTypes = createSlice({
  name: 'organizationCustomerTypes',
  initialState: organizationCustomerTypesAdapter.getInitialState(),
  reducers: {
    setOrganizationCustomerTypes: (state, { payload: { organizationCustomerTypes } }) => {
      organizationCustomerTypesAdapter.setAll(state, organizationCustomerTypes);
    },
  },
});

const selectors = organizationCustomerTypesAdapter.getSelectors(({ organizationCustomerTypes }) => organizationCustomerTypes);

export const getOrganizationCustomerTypes = (state) => selectors.selectAll(state);

export const {
  setOrganizationCustomerTypes,
} = organizationCustomerTypes.actions;

export default organizationCustomerTypes.reducer;
